import { fetchWithHandling } from "utils/common-utils";
import { Filters, GetCommunicationPaginatedRs } from "utils/interfaces";

const API_URL = `${process.env.REACT_APP_BACKEND_API_PREFIX}/api/v1/communications`

export const getAllPaginated = async (
    jwtToken: string,
    onSessionExpired: () => void,
    filters: Filters<any> = {}
): Promise<GetCommunicationPaginatedRs | undefined> => {
    try {
        // Crea la stringa dei query parameters a partire dai filtri
        const queryParams = new URLSearchParams();

        if (filters.pageNumber) {
            queryParams.append('pageNumber', (Number(filters.pageNumber) - 1).toString());
        }

        if (filters.customerId) {
            queryParams.append('customerId', filters.customerId);
        }

        // Aggiungi i parametri alla URL
        const url = queryParams.size > 0 ? `${API_URL}/paginated?${queryParams.toString()}` : `${API_URL}/paginated`;

        const jsonData = await fetchWithHandling(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            },
            () => {
                onSessionExpired();
            }
        );

        return jsonData as GetCommunicationPaginatedRs;
    } catch (error) {
        return undefined;
    }
};

export const sendCommunications = async (
    jwtToken: string,
    onSessionExpired: () => void,
    to: string[], // Array di destinatari
    subject: string,
    modelTypeId: number,
    modelId: number,
    customerIds: number[], // Array di customerId
    files: File[],
): Promise<String> => {
    try {
        const formData = new FormData();
        to.forEach((email) => {
            formData.append('additionalRecipients', email);
        });
        formData.append('subject', subject);
        formData.append('modelTypeId', modelTypeId.toString());
        formData.append('modelId', modelId.toString());
        customerIds.forEach((id) => {
            formData.append('customerIds', id.toString());
        });
        files.forEach((file) => {
            formData.append('files', file);
        });

        const jsonData = await fetchWithHandling(
            API_URL,
            {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: formData,
            },
            () => {
                onSessionExpired();
            }
        );

        return jsonData;
    } catch (error) {
        return undefined;
    }
};

export const downloadAttachment = async (
    jwtToken: string,
    onSessionExpired: () => void,
    s3Key: string
): Promise<string> => {
    try {

        const url = `${API_URL}/attachment?s3Path=${s3Key}`;

        const response = await fetchWithHandling(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            },
            () => {
                onSessionExpired();
            },
            true // Indica che non ci aspettiamo una risposta JSON
        );

        if (!response.ok) {
            throw new Error('Errore durante il download del file');
        }

        const blob: Blob = await response.blob();
        return window.URL.createObjectURL(blob);
    } catch (error) {
        throw error;
    }
};